<template>
    <section>
		<el-row>
			<!--列表-->
			<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
				<el-table-column label="编号" width="100" prop="code"></el-table-column>
				<el-table-column label="限制" width="100" prop="xz"></el-table-column>
				<el-table-column label="统计" width="100" prop="count"></el-table-column>
				<el-table-column label="信息" width="100" prop="msg"></el-table-column>
			</el-table>
		</el-row>
	</section>
</template>
<style scoped>
    /*index*/
    .welinfo {
        height: 32px;
        padding-bottom: 8px;
    }

    .welinfo span {
        float: left;
    }

    .welinfo b {
        padding-left: 8px;
        line-height: 32px;
    }

    .welinfo a {
        padding-left: 15px;
        color: #F56C6C;
    }

    .welinfo a:hover {
        color: #67C23A;
    }

    .welinfo i {
        font-style: normal;
        padding-left: 8px;
        line-height: 32px;
    }

    .xline{border-bottom:solid 2px #ecf5ff; height:5px;}

    .chart-container {
        width: 100%;
        float: left;
    }

    .el-col {
        padding: 30px 20px;
    }
</style>
<script>
	import util from '../common/js/util'
	import { getListPage, delData, saveData } from '../api/api';
	export default {
		data() {
			return {
				datalist: [],
				listLoading:false
			}
		},
		methods: {
			getLists:function(){
				console.log("getLists");
				let para = {
					actionurl:'control/checkDayLimit'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			}
		},
		mounted() {
			this.getLists();
		}
	}	
</script>
<style scoped>
	.el-header {
	  background-color: #FFFFFF;
	  //color: white;
	  text-align: left;
	  line-height: 60px;
	}
	 
	.el-main {
	  margin-top: 60px; /* 头部高度 */
	  padding: 0px;
	}
</style>


// WEBPACK FOOTER //
// Index.vue?32b6b9c5